import { createContext } from "react";

const DF_OT0024Context = createContext();

export { DF_OT0024Context };